import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import PropertyAppResource from "./PropertyAppResource";
import WorkspaceAppResource from "./WorkspaceAppResource";

export const INSURANCE = 'insurance';
export const WARRANTY = 'warranty';
export const TYPES = {
    INSURANCE,
    WARRANTY
};

class HomeownersInsuranceAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'homeowners-insurance';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'homeowners/insurances';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'created_at',
            'updated_at',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'workspaceUuid',
            'propertyUuid',
            'companyName',
            'policyNumber',
            'expirationDate',
            'deductible',
            'liabilityLimit',
            'policyFileUuid',
            'agentName',
            'email',
            'phone',
            'website',
            'type',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspace: WorkspaceAppResource,
            property: PropertyAppResource
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            workspace: 'workspaceUuid',
            property: 'propertyUuid'
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            workspaceUuid: {
                type: 'string',
                presence: true,
            },
            propertyUuid: {
                type: 'string',
            },
            policyFileUuid: {
                type: 'string',
            },
            companyName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            policyNumber: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            expirationDate: {
                datetime: {
                    dateOnly: true
                },
            },
            deductible: {
                numericality: true,
            },
            liabilityLimit: {
                numericality: true,
            },
            agentName: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            email: {
                type: 'string',
                email: true,
                length: {
                    maximum: 255,
                },
            },
            phone: {
                type: 'string',
                format: {
                    pattern: '^([0-9-. \(\)\+]*)',
                    message: 'is invalid.',
                },
                length: {
                    maximum: 255,
                },
            },
            website: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            type: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default HomeownersInsuranceAppResource;
